module.exports = __webpack_public_path__ + "static/media/Arrow.a8417d3b.svg";